import { priceFormat } from '../../../../../util';
import {
  Container,
  TimelineContainer,
  VerticalLine,
  Heading,
  TimelineItem,
  CircleRow,
  Circle,
  Detail,
  OptionLabel,
  CartList,
  CartItem,
  CopyIcon,
  CopiedText,
} from './ChallengeTimeline.styles';
import React from 'react';

export const ChallengeTimeline = ({ steps }) => {
  const [copiedItemSet, setCopiedItemSet] = React.useState(null);
  const copyTimerRef = React.useRef(null);

  const countCompletedSteps = steps.filter((step) => step.completedAt).length;
  const formatItemsForCopy = (items) => {
    return items.join(',\n');
  };

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(formatItemsForCopy(text));
    setCopiedItemSet(id);
    if (copyTimerRef.current) {
      clearTimeout(copyTimerRef.current);
    }
    copyTimerRef.current = setTimeout(() => {
      setCopiedItemSet(null);
      copyTimerRef.current = null;
    }, 3000);
  };

  React.useEffect(() => {
    return () => {
      if (copyTimerRef.current) {
        clearTimeout(copyTimerRef.current);
      }
    };
  }, []);

  return (
    <Container>
      <TimelineContainer>
        <VerticalLine />
        <Heading>
          Steps ({countCompletedSteps}/{steps.length} completed)
        </Heading>

        {steps.map((step, index) => (
          <TimelineItem key={index}>
            <CircleRow>
              {!!step.completedAt ? <Circle src={'/images/blue-circle-check.svg'} /> : <Circle />}
              Step {index + 1}
            </CircleRow>
            <Detail>
              <b>Completed At: {step.completedAt ? new Date(step.completedAt).toLocaleString() : ' N/A'}</b>
            </Detail>
            {Number(step.minimumSpend) > 0 && (
              <Detail>
                <strong>Minimum Spend:</strong> {priceFormat(step.minimumSpend / 100)}{' '}
              </Detail>
            )}
            {step.cartRequirements && step.cartRequirements.length > 0 && (
              <Detail>
                <strong>Cart Requirements:</strong>
                {step.cartRequirements.map((optionSet, idx) => (
                  <div key={idx}>
                    <OptionLabel>
                      {optionSet.length > 1 ? `Item Set ${idx + 1}:` : 'Item Set:'}
                      {copiedItemSet === `${step.id}#${idx}` ? (
                        <CopiedText>Copied!</CopiedText>
                      ) : (
                        <CopyIcon
                          src={'/images/copy.svg'}
                          alt="Copy"
                          onClick={() => handleCopy(optionSet, `${step.id}#${idx}`)}
                          title="Copy items to clipboard"
                        />
                      )}
                    </OptionLabel>
                    <CartList>
                      {optionSet.map((item) => (
                        <CartItem key={item.id}>
                          <span>{item}</span>
                        </CartItem>
                      ))}
                    </CartList>
                  </div>
                ))}
              </Detail>
            )}
          </TimelineItem>
        ))}
      </TimelineContainer>
    </Container>
  );
};
